import { CalendarApi } from "@fullcalendar/core/index.js"
import type FullCalendar from "@fullcalendar/react"
import { useCallback, useState } from "react"
import { calculateEventStartCalendarTimezoneCoerced } from "./timetableZonedDatetime"

export const useFullCalendarApi = (calendarName: string) => {
  const [api, setApi] = useState<CalendarApi | null>(null)
  const setRef = useCallback(
    (fullCalendar: FullCalendar | null) => {
      if (fullCalendar) {
        const api = fullCalendar.getApi()
        window.sagecool.provideCalendar(calendarName, api)
        setApi(api)
      }

      return () => {
        window.sagecool.removeCalendar(calendarName)
      }
    },
    [setApi, calendarName],
  )

  return [setRef, api] as [typeof setRef, typeof api]
}

export function computeFullCalendarEvents({
  cycleLength,
  startTime,
  duration,
  day,
  calendarTimezoneId,
  eventTimezoneId,
  startTemporalZonedDateTime,
  eventTitle,
  extendedProps,
  id = crypto.randomUUID(),
}: {
  cycleLength: number
  startTime: string
  duration: number
  day: number
  calendarTimezoneId: string
  eventTimezoneId: string
  startTemporalZonedDateTime: Temporal.ZonedDateTime
  eventTitle: string
  extendedProps: Record<string, any>
  id?: string
}) {
  const calendarTimezoneStartCoerced =
    calculateEventStartCalendarTimezoneCoerced({
      startTime,
      day,
      calendarTimezoneId,
      eventTimezoneId,
      startTemporalZonedDateTime,
    })
  return [
    -2 * cycleLength,
    -1 * cycleLength,
    0,
    1 * cycleLength,
    2 * cycleLength,
  ].map((offset) => {
    const start = calendarTimezoneStartCoerced.add({ days: offset })
    const end = start.add({ minutes: duration })
    return {
      extendedProps: extendedProps,
      title: eventTitle,
      id,
      start: start.toInstant().toString(),
      end: end.toInstant().toString(),
    }
  })
}
